import { StarFilled } from '@ant-design/icons';

const ShopMarkerSmall = () => {
  const markerStyle = {
    position: 'relative',
    width: '16px',
    height: '24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginRight: '6px'
  } as const;

  const pinHeadStyle = {
    width: '16px',
    height: '16px',
    backgroundColor: '#CCCCCC',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #000000',
    zIndex: 2,
    position: 'relative'
  } as const;

  const pinTailStyle = {
    width: '10px',
    height: '10px',
    backgroundColor: '#CCCCCC',
    clipPath: 'polygon(50% 100%, 0 0, 100% 0)',
    marginTop: '-3px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.3)',
    zIndex: 1
  } as const;

  return (
    <div style={markerStyle}>
      <div style={pinHeadStyle}>
        <StarFilled style={{ color: '#000000', fontSize: '8px' }} />
      </div>
      <div style={pinTailStyle} />
    </div>
  );
};

export default ShopMarkerSmall; 